<a *ngIf="!address || !address.addressID" (click)="openAddOrEditAddress()"
    style="min-width: 10px  !IMPORTANT; min-height: 10px  !IMPORTANT;  line-height: 10px; padding:4px"
    matTooltip="הוסף כתובת" mat-stroked-button>
    <mat-icon style="color: GRAY;">add_box</mat-icon>
</a>

<a style="padding: 4px" *ngIf="address && address.addressID > 0" (click)="openAddOrEditAddress()">
        <i matTooltip="עריכה ופרטים נוספים" class="fa fa-pencil"></i>
    </a>
    